import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useLocalStorage } from "../utils/useLocalStorage";

const ProtectedRoute = ({
  resource,
  authenticatedRedirect,
  permissions,
  children,
}) => {
  const { authenticated, user } = useContext(AuthContext);

  // Local storage
  const [selectedUser, setSelectedUser] = useLocalStorage("selectedUser");

  if (authenticated === undefined) return null;

  if (authenticated) {
    let initialPermissions = permissions;
    let newPermissions =
      // user?.Account?._id === JSON.parse(selectedUser)?._id
      //   ? [...initialPermissions, "user"]
      //   :
      initialPermissions;

    if (newPermissions?.includes(resource)) return children;
    else return <Navigate to={`/app/${authenticatedRedirect}`} replace />;
  }

  return <Navigate to="/login" replace />;
};

export default ProtectedRoute;
